<div class="tw-flex tw-flex-grow tw-justify-center tw-items-center tw-gap-2">
  @if(user()?.agentInfo){
  <app-transfer-availability [agentInfo]="user()!.agentInfo!" (agentInfoChange)="onAgentInfoChange($event)" mode="edit"
    [disabled]="agentInfoLoading()" [softphoneState]="softphoneStateDto()" [softphoneRuntimeState]="softphoneState()" />
  }

  <div class="connection-stats">
    @if(socketConnected) {<i class="pi pi-wifi text-success" matTooltip="Connected to live transfer server."></i>}
    @else {<i class="pi pi-wifi text-warning tw-animate-pulse" matTooltip="Connecting..."></i>}

    <div [matMenuTriggerFor]="incomingCallMenu"></div>
    <mat-menu #incomingCallMenu="matMenu" class="w-fit-content">
      <ng-template matMenuContent>
        @if(incomingCall(); as incoming) {
        <div class="tw-flex tw-flex-col tw-gap-2 tw-p-4 tw-max-w-96">
          <div class="tg-section-title"> Incoming Transfer </div>

          <app-transfer-info [info]="incomingTransferInfo()" emptyLabel="Lead" />

          <div class="tw-flex tw-justify-end tw-gap-4">
            <button pButton label="Close" class="p-button-outlined p-button-sm" (click)="clearIncomingCall()">
            </button>
            <!-- <button pButton label="Reject Transfer" [loading]="rejecting" class="p-button-danger p-button-sm"
              (click)="rejectTransfer()">
            </button> -->
          </div>
        </div>
        }
      </ng-template>
    </mat-menu>
  </div>
</div>
